import React from "react";
import Select from "react-select";
import { useTranslation } from 'react-i18next';
const FormSelectSelection = ({
  label,
  options = [],
  value = null,
  onChange = () => { },
  isMulti = false,
  isClearable = false,
  disabled = false,
  colSize = 4
}) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };
  const { t } = useTranslation();
  const colClass = `col-lg-${colSize} mb-3`;
  return (
    <div className={colClass}>
      <div className="form-group">
        {label && <label className="labelDescription"> {t(label)}</label>}
        <Select
          options={options}
          value={value}
          onChange={handleChange}
          isMulti={isMulti}
          isClearable={isClearable}
          isDisabled={disabled}
        />
      </div>
    </div>
  );
};

export default FormSelectSelection;
